import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LineChartIcon, LeafIcon, PlugZapIcon } from 'lucide-react';
const features = [{
  icon: ShieldCheckIcon,
  title: 'Brand-safe by default',
  text: 'Controlled channels and de-branding options keep your recovered stock away from the grey market.'
}, {
  icon: LineChartIcon,
  title: 'Real-time recovery ledger',
  text: 'Track every unit, channel, and dollar recovered in a single live dashboard your finance team will love.'
}, {
  icon: LeafIcon,
  title: 'Divert from landfill',
  text: 'Resale, refurbishment, and verified recycling turn write-offs into measurable sustainability wins.'
}, {
  icon: PlugZapIcon,
  title: 'Plugs into your stack',
  text: 'Native connectors for Shopify, NetSuite, and major 3PLs mean you can be live in under two weeks.'
}];
export function Features() {
  return <section id="why" className="mx-auto max-w-6xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-942" data-mp="2ut4y6pwx1a1">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-943" data-mp="2xtex5qevycdo">
        <div data-id="element-944" data-mp="2sutyhvfa80rc">
          <span className="text-xs font-semibold uppercase tracking-wider text-forest" data-id="element-945" data-mp="2svdcx25q470m">
            Why manyco
          </span>
          <h2 className="mt-2 font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl" data-id="element-946" data-mp="36veg4o9gnqj9">
            Recover value without cheapening your brand.
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-ink/65" data-id="element-947" data-mp="3gs9ff9dk5uyl">
            Liquidation destroys margins and brand equity. manyco.ai finds the highest-value
            home for every stranded unit — so you recover cash and protect your name.
          </p>
          <div className="mt-8 overflow-hidden rounded-2xl border border-ink/10" data-id="element-948" data-mp="3ljizzvk9283m">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f7dcb750-3d18-4616-bb6d-7af4c23810e0.jpg" alt="Isometric illustration of an organized warehouse shelf with labeled boxes" className="h-full w-full object-cover" data-id="element-949" data-mp="3lllyl3zgx9jy" />
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2" data-id="element-950" data-mp="2x5vz12fcf620">
          {features.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="rounded-2xl border border-ink/10 bg-paper p-6" data-id="element-951" data-mp="317hhd3anccjl" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-forest/10 text-forest" data-id="element-952" data-mp="3fv2gkm4ehrm8">
                <f.icon className="h-5 w-5" data-id="element-953" data-mp="3kw8d6v16lz11" />
              </span>
              <h3 className="mt-4 text-base font-semibold text-ink" data-id="element-954" data-mp="3oxbttjr1zz3b">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/65" data-id="element-955" data-mp="1qhxnylgod2uq">{f.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}